import React from 'react'
import { Typography } from '@mui/material'
import { DatePickerV2, labraUIDateFormat } from '@labrav/react-components'
import { FormikProps, useFormikContext } from 'formik'
import { isEmpty } from 'lodash'

import { useStyles } from './ServiceDate.style'
import type { AgreementBasedOffer } from '../../../../modules/subscription/reducer'
import { agreementServiceExpirationDateField } from '../../../../mocks/serviceEndDateField'
import { useSelector } from '../../../../store'
import { dateAndTimeConversion } from '../../../../common/utils/dateAndTimeConversion'

export const ServiceDate = ({ subscriptionId }: { subscriptionId: string }) => {
  const formikProps = useFormikContext() as FormikProps<AgreementBasedOffer>
  const { values, errors, touched } = formikProps
  const subscriptionDetail = useSelector(
    state => state?.subscriptions?.currentSubscription?.[subscriptionId] || null
  )
  const serviceEndDateField = {
    ...agreementServiceExpirationDateField,
    defaultValue: !isEmpty(values?.subscriptionEndDate)
      ? values?.subscriptionEndDate
      : null,
  }

  const timeZone = useSelector<string>(
    state =>
      state.userProfile.userProfile.timeZone ||
      state.userProfile.userProfile.defaultTimeZone ||
      'UTC'
  )
  const { modifiedDate: serviceExpiryDate } =
    !isEmpty(values) && values?.previousSubscriptionEndDate
      ? dateAndTimeConversion(values?.previousSubscriptionEndDate, timeZone)
      : { modifiedDate: '-' }
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.previousDateWrapper}>
        <Typography className={classes.title}>
          Previous service end date
        </Typography>
        <Typography className={classes.value}>{serviceExpiryDate}</Typography>
      </div>
      <div className={classes.serviceEndDateWrapper}>
        <div>
          <Typography className={classes.title} data-testid="service-end-date">
            Service end date
          </Typography>
          <Typography className={classes.subValue}>
            Final date the services in this offer can be used
          </Typography>
        </div>
      </div>
      <div className={classes.datePicker} data-testid="date-picker">
        <DatePickerV2
          format={labraUIDateFormat}
          views={['year', 'month', 'day']}
          field={serviceEndDateField}
          showErrorHelper={
            !!touched.subscriptionEndDate &&
            !isEmpty(errors.subscriptionEndDate)
          }
          fieldId={'subscriptionEndDate'}
          formik={
            formikProps as unknown as FormikProps<Record<string, unknown>>
          }
          errorHelperText={
            (!!touched.subscriptionEndDate && errors.subscriptionEndDate) || ''
          }
        />
      </div>
    </div>
  )
}
